<div class="experience-form-container">
  <form nz-form [formGroup]="form" [nzLayout]="'vertical'">

    <div class="form-section">
      <nz-form-item>
        <nz-form-label nzRequired>Mode</nz-form-label>
        <nz-form-control>
          <nz-radio-group formControlName="experience_mode">
            <label nz-radio [nzValue]="'tasting'">Tasting</label>
            <label nz-radio [nzValue]="'non_tasting'">Non-Tasting</label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>

      <!-- Experience Type -->
      @if (form.get('experience_mode')?.value === 'non_tasting') {
        <nz-form-item>
          <nz-form-label nzRequired>Experience Type</nz-form-label>
          <nz-form-control>
            <nz-select 
              nzShowSearch 
              nzAllowClear 
              formControlName="experience_type"
              nzPlaceHolder="Select experience type">
              <nz-option 
                *ngFor="let v of filteredExperienceTypes" 
                [nzValue]="v.id" 
                [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      }

      <!-- Experience Category (cascading) -->
      <nz-form-item>
        <nz-form-label nzRequired>Experience Category</nz-form-label>
        <nz-form-control>
          <nz-select 
            nzShowSearch 
            nzAllowClear 
            formControlName="experience_category"
            nzPlaceHolder="Select experience category"
            [nzDisabled]="!form.get('experience_type')?.value">
            <nz-option 
              *ngFor="let v of experienceCategoryResponseModel.value.results" 
              [nzValue]="v.id" 
              [nzLabel]="v.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <!-- Experience Testing Type (conditional - only for Tasting Experience) -->
      @if (isTastingExperience) {
        <nz-form-item>
          <nz-form-label nzRequired>Experience Testing Type</nz-form-label>
          <nz-form-control>
            <nz-select 
              nzShowSearch 
              nzAllowClear 
              formControlName="experience_testing_type"
              nzPlaceHolder="Select experience testing type">
              <nz-option 
                *ngFor="let v of experienceTestingTypeResponseModel.value.results" 
                [nzValue]="v.id" 
                [nzLabel]="v.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      }

      <nz-form-item>
        <nz-form-control>
          <button nz-button nzType="primary" (click)="onSave()" [disabled]="form.invalid">
            Submit
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>

  </form>
</div>